import { Box, Pagination } from "@mui/material";
import { useState } from 'react';
import { useLoaderData } from "react-router-dom";
import { MainContainer } from "../../components/MainContainerComp";
import { doFetch } from "../../utils/doFetch";
import { DispatchSlip } from './DispatchSlip';
import { IDespatchSlipData } from "./DispatchSlipData";
import { DispatchSlipDetails } from "./DispatchSlipDetails";
import { DispatchSlipFooter } from "./DispatchSlipFooter";
import { paginationStyles } from "./styled";

export const slipPreviewRouteLoader = async ({ request, params }: { request: any, params: any }) => {
  const { orderDetailId, groupId } = params;
  return doFetch(`slip-preview-slip/${groupId ? 'groupId/' : ''}${orderDetailId || groupId}`, { signal: request.signal }, true, true)
}

export const SlipPreviewRoute = () => {
  const data = useLoaderData() as IDespatchSlipData;
  const totalPages = data.slipDetails.details.length;
  const [page, setPage] = useState<number>(1);

  const onPageChange = (event: React.ChangeEvent<unknown>, page: number) =>
    setPage(page);

  return (
    <>
      {totalPages > 1 && <Pagination
        page={page}
        sx={paginationStyles}
        onChange={onPageChange}
        color="primary"
        count={totalPages}
        variant="outlined"
        shape="rounded"
      />}
      <Box sx={{ minWidth: '600px', minHeight: '400px' }}>
        <MainContainer>
          <DispatchSlip page={page} slipDetails={data.slipDetails} />
          <DispatchSlipDetails page={page} slipDetails={data.slipDetails} />
          <DispatchSlipFooter slipDetails={data.slipDetails} />
        </MainContainer>
      </Box>
      {totalPages > 1 && <Pagination
        page={page}
        sx={paginationStyles}
        onChange={onPageChange}
        color="primary"
        count={totalPages}
        variant="outlined"
        shape="rounded"
      />}
    </>
  )
}